<template>
  <div class="container-fluid">
    <div class="row mt-4">
     <div class="col">
      <p class="page-title"><i class="fas fa-file-invoice"></i> Returned Orders</p>
     </div>
    </div>
    <div class="row">
      <div class="col">
        <marketplaces-grid
          :data="gridData"
          :columns="gridColumns"
          :filter-key="searchQuery"
          @showNoteModal="onShowNoteModal"
          @changeStatus="onChangeStatus"
        />
        <b-pagination
          size="sm"
          v-model="page"
          :per-page="10000"
          :total-rows="totalRows"
          align="center"
          @change="changePage($event)"
        />
      </div>
    </div>
    <b-modal
      v-model="noteModal"
      ref="noteModal"
      @ok="updateNote"
      :title="`Notes`"
      :ok-disabled="logTextArea === ''"
      ok-title="Save"
      no-close-on-backdrop no-close-on-esc>
        <textarea
          class="form-control"
          name=""
          id=""
          rows="3"
          v-model="logTextArea"
          maxlength="255"
        ></textarea>
      </b-modal>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
//import lang from 'element-ui/lib/locale/lang/en';
//import locale from 'element-ui/lib/locale';
//import router from '@/router';
//import bModal from 'bootstrap-vue/esm/components/modal/modal';
//import bPagination from 'bootstrap-vue/esm/components/pagination/pagination';
import { BModal, BPagination } from 'bootstrap-vue';
import mGrid from '../../components/MarketplacesGrid/MarketplacesGrid.vue';
import OrderApiRequest from '@/components/ApiRequester/Order.js';
import { MessageBox } from 'element-ui';
export default {
  name: 'home',
  components: {
    'marketplaces-grid': mGrid,
    'b-pagination': BPagination,
    'b-modal': BModal,
  },
    data() {
    return {
      updatedId:0,
      startDate: "",
      endDate: "",
      searchQuery: '',
      totalRows: 0,
      page: 1,
      logTextArea: '',
      noteModal: false,
      gridData: [],
      gridColumns: [
        {
          column: 'Order Id', index: 'order_id', type: 'raw',
        },
        {
          column: 'Name', index: 'name', type: 'raw',
        },
        {
          column: 'Email', index: 'email', type: 'raw',
        },
        {
          column: 'Note', index: 'note', type: 'icon', icon_class:"fa fa-sticky-note hand-mouse", eventName:"showNoteModal",
        },
        {
          column: 'Address Line 1', index: 'address_line_1', type: 'raw',
        },
        {
          column: 'City', index: 'city', type: 'raw',
        },
        {
          column: 'State', index: 'state', type: 'raw',
        },
        {
          column: 'Status', index: 'status', type: 'select', eventName:"changeStatus",
        }
      ],

    };
  },
  mounted() {
      this.calculateDays(100);
      document.getElementById('loader').classList.add('active');
      const orderApiRequest = new OrderApiRequest();
      let payload = {
        page: this.page,
        startDate: this.startDate,
        endDate: this.endDate
      };
       orderApiRequest.returnedOrders(payload).then((response) => {
         this.gridData = response.data.data;
         this.totalRows = response.data.total;
         document.getElementById('loader').classList.remove('active');
       }).catch(() => {
          document.getElementById('loader').classList.remove('active');
       });
  },
  methods: {
    calculateDays(lastUnitDays){
      const todayString = new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
      const endDate = new Date(todayString);
      endDate.setDate(endDate.getDate()+3);
      const startDate = endDate;
      this.endDate = endDate.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });

      startDate.setDate(endDate.getDate() - lastUnitDays + 1 );
      this.startDate = startDate.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
      this.endDate = this.formatDate(this.endDate);
      this.startDate = this.formatDate(this.startDate);
    },
    formatDate(date) {
      const today = new Date(date);
      let dd = today.getDate();
      let mm = today.getMonth() + 1; // January is 0!
      const yyyy = today.getFullYear();
      if (dd < 10) {
        dd = `0${dd}`;
      }
      if (mm < 10) {
        mm = `0${mm}`;
      }
      return `${yyyy}-${mm}-${dd}`;
    },
    getDaysFromMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
    changePage(page){
      let payload = {
        page,
        startDate: this.startDate,
        endDate: this.endDate
      }
      const orderApiRequest = new OrderApiRequest();
      document.getElementById('loader').classList.add('active');
      this.gridData = [];
      orderApiRequest.returnedOrders(payload).then((response) => {

          this.gridData = response.data.data,
          this.totalRows = response.data.total
          document.getElementById('loader').classList.remove('active');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      });
    },
    onShowNoteModal(row){
      this.logTextArea = row.note;
      this.updatedId = row.id;
      this.noteModal = true;
    },
    updateNote(){
      const payload = {
        note: this.logTextArea,
        order_id: this.updatedId
      };
      document.getElementById('loader').classList.add('active');
      const orderApiRequest = new OrderApiRequest();
      orderApiRequest.updateOrder(payload).then(() => {
        document.getElementById('loader').classList.remove('active');
        this.changePage(1);
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      });
      this.noteModal = false;
    },
    onChangeStatus(param){
      MessageBox.confirm(`Are you sure you want to change the status to ${param[1]}`, 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        document.getElementById('loader').classList.add('active');

        const payload = {
          status: param[1],
          order_id: param[0].id
        };
        const orderApiRequest = new OrderApiRequest();
        orderApiRequest.updateOrder(payload).then(() => {
          document.getElementById('loader').classList.remove('active');
          this.changePage(1);
        });
      }).catch((error) => {
        console.log(error);
        document.getElementById('loader').classList.remove('active');
      });
    }
  }
};
</script>
